import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <g>
    <path d="M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h11.2l-2-2H6V4h7v5h5v4.2l2 2V8l-6-6H6zm8.9 12.9v2l5 5 2-2-5-5h-2zm7.9 6l-1.9 1.9.9.9c.2.2.5.2.7 0l1.2-1.2c.2-.2.2-.5 0-.7l-.9-.9z" />
  </g>,
  'FileEdit',
);
